import React from 'react';
import environment from '../environment';
import { MonitoringErrorBoundary } from '@asurion-core/frontend-utils/lib/WebObservability';

const MonitoringErrorWrapper = ({ children }) => {
  return environment.observability.isTelemetryEnabled ? (
    <MonitoringErrorBoundary>{children}</MonitoringErrorBoundary>
  ) : (
    <>{children}</>
  );
};

export default MonitoringErrorWrapper;
